import { render, staticRenderFns } from "./SupervisorRejectModal.vue?vue&type=template&id=10f102bc"
import script from "./SupervisorRejectModal.vue?vue&type=script&lang=js"
export * from "./SupervisorRejectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports